import React from "react";
import { Stack, Avatar, Typography } from "@mui/material";

interface Props {
    client: {
        name?: string;
        lastname?: string;
        photoURL?: string;
    };
    size?: number;
    spacing?: number;
    titleVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

const ClientAvatar: React.FC<Props> = ({
    client,
    size = 100,
    spacing = 2,
    titleVariant = "h3"
}) => {
    const name = client?.name || "";
    const lastname = client?.lastname || "";
    const initials = (name.charAt(0) + lastname.charAt(0)).toUpperCase();

    return (
        <Stack spacing={spacing} alignItems="center" justifyContent="center">
            <Avatar
                src={client?.photoURL}
                sx={{
                    width: size,
                    height: size,
                    fontSize: size * 0.32,
                    fontWeight: 300,
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                }}
            >
                {initials}
            </Avatar>
            <Typography textAlign="center" variant={titleVariant}>
                {name} {lastname}
            </Typography>
        </Stack>
    );
};

export default ClientAvatar;
